import React from 'react';
import { ProtectedGate } from './ProtectedLayout';

interface Props {
  component: React.ComponentType<any>;
  componentProps?: any;
  allowedRoles?: string[];
}

/**
 * One protected page outside the protected layout (the account pages): the same gate and provider
 * stack as `ProtectedLayout`, around a single component.
 */
const ProtectedRoute: React.FC<Props> = ({
  component: Component,
  allowedRoles,
  componentProps,
}) => (
  <ProtectedGate allowedRoles={allowedRoles}>
    <Component {...componentProps} />
  </ProtectedGate>
);

export default ProtectedRoute;
